import type { GetStaticPaths, GetStaticProps } from 'next';
import EnrolmentForm from '@/components/EnrolmentForm';
import { ErrorPage } from '@/components/ErrorPage';
import { Success } from '@/components/Success';
import { useGlobalContext } from '@/components/GlobalProvider';
import { Programmes, View } from '@/utils/constants';
import messages from '@/locales/en';

type Props = {
  programmeId: Programmes;
  isError?: boolean;
};

const SignUp = (props: Props) => {
  const { currentView } = useGlobalContext();

  if (currentView === View.ERROR || props.isError)
    return <ErrorPage failedEnrolment={currentView === View.ERROR} />;
  if (currentView === View.SUCCESS) return <Success />;

  return <EnrolmentForm programmeId={props.programmeId} />;
};

const partnerToProgrammeId: Record<string, Programmes> = {
  iberia: Programmes.IBP,
  aerlingus: Programmes.AERC,
};

export const getStaticPaths: GetStaticPaths = async () => ({
  paths: [
    { params: { partner: [] } },
    { params: { partner: ['iberia'] } },
    { params: { partner: ['aerlingus'] } },
  ],
  fallback: false,
});

export const getStaticProps: GetStaticProps = async context => {
  const { partner } = context.params ?? {};
  const segments = partner as string[] | undefined;
  const partnerSlug = segments?.[0];

  if (partnerSlug && !partnerToProgrammeId[partnerSlug]) {
    return {
      notFound: true,
    };
  }

  const programmeId = partnerSlug
    ? partnerToProgrammeId[partnerSlug]
    : Programmes.BAEC;

  return {
    props: {
      programmeId,
      messages,
    },
  };
};

export default SignUp;
